import {
  useTheme,
  Box,
  Stepper,
  Step,
  StepLabel,
  Typography,
  Button,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Cookies from "universal-cookie";
import { LoadingBlur } from "../LoadingBlur";
import { tokens } from "../../theme/theme";
import ExoAlert from "./ExoAlert";

const cookies = new Cookies();
/*
  const steps = [
    {
      label: "testtitel",
      subLabel: "optional",
      discription: "discription - 1 sdsd", //optional
      noControlls: true, //optional
      valid: true, //optional
      content: ({
        step,
        activeStep,
        setActiveStep,
        dataCollection,
        updateValidation,
        updateDataCollection,
      }) => (
        <Box>
          <h1>{step.label}</h1>
        </Box>
      ),
    },
  ];

  const finalStep = {
    operation: ({dataCollection, handleResponse, setIsLoading}) => { ... }, // your operation with the data
    content: (response) => <h1>YAAAHHH</h1>, // component with final operations and the feedback
  };
*/

const ExoStepper = ({
  onClose = () => {},
  data,
  orientation = "horizontal",
  finalStep = {},
  startDataCollection,
  message,
  debug = false,
  label = "",
  previewDocument,
  className = "",
  onSave,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();
  var key = 0;
  const [steps, setSteps] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [dataCollection, setDataCollection] = useState({});

  useEffect(() => {
    if (data) setSteps(data);
    setDataCollection({ ...startDataCollection });
  }, [data, startDataCollection]);

  function handleStepClick(clickedStep) {
    var stepValideIndex = clickedStep - 1;
    if (stepValideIndex < 0) stepValideIndex = 0;
    if (!steps[stepValideIndex].valid) return;
    setActiveStep(clickedStep);
  }
  function handleReset() {
    setActiveStep(0);
    setDataCollection(startDataCollection || {});
  }

  // document preview
  const containerRef = useRef(null);
  const breakWidth = "1300px";
  const [documentContainerWidth, setDocumentContainerWidth] = useState(0);
  const [openPreview, setOpenPreview] = useState(null);

  useEffect(() => {
    const documentPreviewCookies = cookies.get("documentPreview") === "true";

    if (documentPreviewCookies === undefined) {
      updateOpenPreview(true);
    } else {
      setOpenPreview(documentPreviewCookies);
    }
  }, []);

  useEffect(() => {
    if (!containerRef) return;

    // Attach event listener for window resize
    window.addEventListener("resize", handleResize);

    // Initial setup
    handleResize();

    // Cleanup the event listener when the component is unmounted
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [containerRef]);

  function handleResize() {
    if (containerRef.current) {
      const containerHeight = containerRef.current.offsetHeight;
      const containerWidth = containerHeight / 1.4142;
      setDocumentContainerWidth(containerWidth);
    }
  }

  function updateOpenPreview(state) {
    cookies.set("documentPreview", state, {
      path: "/",
    });
    setOpenPreview(state);
  }

  return (
    <Box
      className={"flex flex-row h-full w-full overflow-hidden pb-2" + className}
    >
      <Box
        className="h-full relative pt-3 flex flex-col gap-2 overflow-hidden px-1"
        sx={{
          transition: "min-width 0.4s",
          minWidth: "100%",
          paddingRight: "0px",
          [`@media (min-width: ${breakWidth})`]: {
            minWidth: openPreview
              ? `calc(100% - ${documentContainerWidth}px)`
              : "100%",
            paddingRight: previewDocument ? "36px" : "",
          },
        }}
      >
        {label && (
          <Typography variant="h2" textAlign="center" className="pb-3">
            {label}
          </Typography>
        )}
        {debug && (
          <>
            <Button
              color="warning"
              variant="contained"
              onClick={() => console.log(dataCollection)}
              sx={{
                position: "absolute",
                top: "0",
                left: "0",
              }}
            >
              LOG DATA
            </Button>
            <Button
              color="warning"
              variant="contained"
              onClick={() => console.log(steps)}
              sx={{
                position: "absolute",
                top: "40px",
                left: "0",
              }}
            >
              LOG STEPS
            </Button>
          </>
        )}
        <Stepper
          className="w-full overflow-auto"
          activeStep={activeStep}
          orientation={orientation}
          sx={{ minHeight: "40px" }}
        >
          {steps.map((step, index) => (
            <Step key={step.label + "-" + index}>
              <StepLabel
                sx={{
                  "& .MuiStepLabel-iconContainer": {
                    height: "22px",
                  },
                  "& .MuiStepLabel-label.Mui-active": {
                    color: theme.palette.secondary.main,
                    fontWeight: 700,
                  },
                }}
                className=" cursor-pointer"
                onClick={() => handleStepClick(index)}
                optional={
                  step.subLabel && (
                    <Typography variant="caption">{step.subLabel}</Typography>
                  )
                }
              >
                {step.label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        {orientation != "vertical" && (
          <ActiveStep
            previewDocument={previewDocument}
            onClose={onClose}
            steps={steps}
            setSteps={setSteps}
            finalStep={finalStep}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            dataCollection={dataCollection}
            setDataCollection={setDataCollection}
            isVertical={orientation === "vertical"}
            message={message}
            onReset={handleReset}
            onSave={onSave}
          />
        )}
      </Box>
    </Box>
  );
};

const ActiveStep = ({
  onClose,
  steps,
  setSteps,
  activeStep,
  setActiveStep,
  finalStep,
  dataCollection,
  setDataCollection,
  previewDocument,
  isVertical,
  message,
  onReset,
  onSave,
}) => {
  const updateValidation = (valid) => {
    var newSteps = steps;
    newSteps[activeStep].valid = valid;
    setSteps([...newSteps]);
  };

  const updateDataCollection = (insertData) => {
    setDataCollection({ ...dataCollection, ...insertData });
  };

  return (
    <Box className="w-full h-full flex flex-col px-4 overflow-hidden">
      {activeStep === steps.length ? (
        <FinalStep
          finalStep={finalStep}
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          dataCollection={dataCollection}
          steps={steps}
          message={message}
          onReset={onReset}
          onClose={onClose}
        />
      ) : (
        <Box className="flex flex-col w-full h-full overflow-hidden">
          {steps[activeStep].discription && (
            <Typography>{steps[activeStep].discription}</Typography>
          )}
          <Box
            className=" w-full overflow-y-auto flex flex-col h-full"
            sx={{
              paddingBottom: "10px",
            }}
          >
            {steps[activeStep].content({
              steps: steps,
              step: steps[activeStep],
              activeStep: activeStep,
              setActiveStep: setActiveStep,
              dataCollection: dataCollection,
              updateValidation: updateValidation,
              updateDataCollection: updateDataCollection,
            })}
          </Box>
          {!steps[activeStep].noControlls && (
            <Controls
              dataCollection={dataCollection}
              previewDocument={previewDocument}
              onClose={onClose}
              steps={steps}
              activeStep={activeStep}
              setActiveStep={setActiveStep}
              lastStep={activeStep + 1 == steps.length}
              onSave={onSave}
            />
          )}
        </Box>
      )}
    </Box>
  );
};

const FinalStep = ({
  finalStep,
  setActiveStep,
  dataCollection,
  steps,
  activeStep,
  message = "Loading...",
  onReset,
  onClose,
}) => {
  const { t } = useTranslation();
  const [success, setSuccess] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [response, setResponse] = useState({});

  function handleResponse(data, state) {
    setSuccess(true);
    setResponse(data);
  }

  function handleError(error, status) {
    setSuccess(false);
    setResponse(error);
  }

  useEffect(() => {
    if (steps.length !== 0 && activeStep === steps.length) {
      finalStep.operation({
        dataCollection,
        handleResponse,
        handleError,
        setIsLoading,
      });
    }
  }, [activeStep]);

  return (
    <>
      <ExoAlert
        open={success === false}
        onClose={() => {
          setActiveStep(activeStep - 1);
          setSuccess(null);
        }}
        alert={{
          type: "error",
          cancleLabel: "Ok",
          message: response && response.message,
        }}
      />
      <LoadingBlur active={isLoading} text={message} />
    </>
  );
};

export const Controls = ({
  onClose = {},
  steps,
  lastStep = false,
  activeStep,
  setActiveStep,
  btnNext = true,
  btnBack = true,
  dataCollection = {},
  previewDocument,
  onSave,
}) => {
  const { t } = useTranslation();
  const valid = (steps && steps[activeStep].valid) || false;
  const handleNext = () => {
    if (!lastStep || !previewDocument) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else {
      setOpenDialogPreview(true);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  function handleCancle() {
    setOpenDialogPreview(false);
  }

  function handleSubmit() {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setOpenDialogPreview(false);
  }

  // preview
  const [openDialogPreview, setOpenDialogPreview] = useState(false);
  return (
    <Box className="p-2 flex flex-row w-full justify-between bottom-0 left-0">
      {btnBack && (
        <>
          {activeStep == 0 ? (
            <Button onClick={onClose} color="error">
              {t("Close")}
            </Button>
          ) : (
            <Button onClick={handleBack} disabled={!activeStep} color="error">
              {t("Back")}
            </Button>
          )}
        </>
      )}
      <Box className="flex flex-row gap-2">
        {onSave && (
          <Button
            onClick={() => onSave(dataCollection)}
            color="success"
            variant="outlined"
            disabled={!valid}
          >
            {t("Save")}
          </Button>
        )}
        {btnNext && (
          <Button
            onClick={handleNext}
            color={lastStep && !onSave ? "success" : "primary"}
            variant="contained"
            disabled={!valid || (lastStep && Boolean(onSave))}
          >
            {lastStep && !onSave ? t("Finish") : t("Next")}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default ExoStepper;
